export default __webpack_public_path__ + "static/media/playStoreIcon.933e96db.png";